<p><a [queryParams]='getTotalQueryParams()' [routerLink]='route'>{{ total || 0 }}</a>/<a
  [queryParams]='getActiveQueryParams()'
  [routerLink]='route'>{{ active || 0 }}</a>/{{ contactsInCampaign || 0 }}</p>
